export default {
  title: "Error",
  notFound: "Página no encontrada",
  goBack: "Volver al inicio",
}
